export default __webpack_public_path__ + "static/media/single_add_icon.5d5a937f.svg";